<template>
    <div class="popover">
        <Form :rules="rules" ref="form" :model="form" label-width="120px" size="mini">          
            <FormItem label="问题描述：" prop="content">
                <Input placeholder="1~1000字" type="textarea" :autosize="{minRows:2, maxRows:4}" v-model="form.content" clearable></Input>
            </FormItem>
            <FormItem label="联系人：" prop="contantname">
                <Input v-model="form.contantname" placeholder="业务员联系解决问题的老师"></Input>
            </FormItem>
            <FormItem label="联系方式：" prop="contactinfo">
                <Input v-model="form.contactinfo" placeholder="业务员联系解决问题的老师的联系方式"></Input>
            </FormItem>
            <FormItem label="常用联系方式：" prop="contantways">
                <Select v-model="form.contantways"  placeholder="请选择">
                    <Option :value="0" label="电话"></Option>
                    <Option :value="1" label="QQ"></Option>
                    <Option :value="2" label="邮箱"></Option>
                    <Option :value="3" label="微信"></Option>
                </Select>
            </FormItem>
            <FormItem label="附件：" prop="attrid">
                <Upload class="upload-fun" drag multiple :on-success="successUpload" :accept="accept" :action="uploadUrl" :file-list="fileList" :before-remove="beforeRemove">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div slot="tip" class="tip">只能上传格式为jpg、png、pdf、word的文件</div>
                </Upload>
            </FormItem>
        </Form>
        <div class="btn_box" style="padding-left:120px;margin-top:40px;text-align:left;">
            <Button type="primary" class="btn_add_sure" @click="save">保存</Button>
            <Button class="btn_add_canle" @click="cancel">取消</Button>
        </div>
    </div>
</template>

<script>
import { Button, Form, FormItem, Input, Select, Option, Upload } from 'element-ui'
import Message from '../../common/utils/message' 
// import { getUserInfo } from 'libs/utils/localStorage.js'
    import Cookies from 'js-cookie'
import Axios from 'axios'

export default {
    props:[ 'type', 'data' ],
    data(){
        return {
            user: Cookies(),
            // user: getUserInfo(),
            form:{
                cissueid:'1',//关联客户问题
                fkorderid:'',
                content: '',
                contantname: '',
                contantways: 0,
                contactinfo:'',
                attrid:'',
                // createuser:'',
                // createuserid:'',
                cpkid: Cookies.get('erpGid'),
                // mid:'',
                // mname:'',
                // cname:'',
                // ywlxpkid:'',
                // ywlx:'',
                // tsglx:'',
            },
            rules: {
                content: [
                    { required: true, message: '请输入问题描述！', trigger: 'blur' },
                    { max: 1000, message: '字数不能超过1000！', trigger: 'blur' }
                ],
                contantname: [
                    { required: true, message: '请输入联系人！', trigger: 'blur' },
                    { max: 100, message: '字数不能超过100！', trigger: 'blur' }
                ],
                contactinfo: [
                    { required: true, message: '请输入联系方式！', trigger: 'blur' },
                    { max: 100, message: '字数不能超过100！', trigger: 'blur' }
                ],
                contantways:[
                    { required: true, message: '请选择常用联系方式！', trigger: 'change' },
                ]
            },
            uploadUrl:'/sxerp/pt/erpservice/rattachment/UpLoadFile',
            fileList:[],
            fileIds:[],
            accept:'.png,.jpg,.pdf,.doc,.docx',
        }
    },
    components: { Button, Form, FormItem, Input, Select, Option, Upload },
    created(){
        let vm = this;
        // vm.form.createuserid = '';
        // vm.form.createuser = '客户';
        // vm.form.cpkid = vm.user.pkID;
        // vm.form.mid = vm.user.cussubjectid;
        // vm.form.mname = vm.user.SubjectName;
        // vm.form.cname = vm.user.CustomerName;
        // vm.form.ywlxpkid = vm.user.CustomerType;
        // vm.form.ywlx = vm.user.CusTypeName;
        // vm.form.tsglx = vm.user.cusywlx;
    },
    mounted(){
        let vm = this;
        //修改
        if(vm.type == '1'){
            vm.form.fkorderid = vm.data.fkorderid;
            vm.form.content = vm.data.content;
            vm.form.contantname = vm.data.contantname;
            vm.form.contactinfo = vm.data.contactinfo;
            vm.form.contantways = Number(vm.data.contantways);
            // if(vm.data.attrid){//有文件
                // vm.form.attrid = vm.data.attrid;
                // vm.fileIds =  [vm.data.attrid];
                // vm.fileList.push({
                //     id:vm.data.attrid,name:vm.data.attname
                // });
            // }
            //查询附件
            vm.getTenderFileList(vm.data.pkid);

        }
    },
    methods:{
         //查询合同附件
        getTenderFileList(id){
            let vm = this;
            Axios.post('/sxerp/pt/erpservice/rattachment/GetModelList', {
                AttType: 8,
                RelationID: id
            },{
                headers:{
                    'Content-Type':'application/json'
                }
            }).then(res => {
                if(res.status){
                    res.data.data.forEach((item, i) => {
                        var obj = {};
                        vm.$set(obj, 'name', item.attname);
                        vm.$set(obj, 'id', item.pkid);
                        // vm.$set(obj, 'url', '');
                        vm.fileList.push(obj);
                        vm.fileIds.push(item.pkid);
                    });
                }
            }).catch(err => {

            });
        },
         //合同TenderId绑定合同附件
        bindTenderAttr(id){
            let vm = this;
            Axios.post('/sxerp/pt/erpservice/rattachment/updateAttRelationid',{
                pkids: vm.fileIds.length > 0 ? vm.fileIds.join() : '-1', //多个文件id
                relationid: id,  //合同id
                atttype: 8
            },{
                headers:{
                    'Content-Type':'application/json'
                }
            }).then(res => {
                if (res.status) {
                }
            }).catch(err => {
                
            });
        },
        //删除文件
        beforeRemove(file, list){
            let vm = this;
            let index = vm.fileIds.indexOf(file.id);
            vm.fileIds.splice(index, 1);
        },
        //上次成功
        successUpload(res, file, list){
            let vm = this;
            if(res.status){
                vm.fileList = list;
                vm.fileIds.push(res.data);
            }
        },
        save(){
            let vm = this,
                params = vm.form,
                header = {},
                url = '/sxerp/pt/erpservice/crmworkorderissue/saveCustomeIssue'; //默认新增   
            // params.attrid = vm.fileIds.join();
            // params.contantways =  vm.form.contantways.join();
            vm.$refs['form'].validate((valid) => {
                if (valid) {
                    params.pkid = vm.data.pkid;
                    if(vm.type == '1'){ //修改
                        url = '/sxerp/pt/erpservice/crmworkorderissue/update';
                        header = {
                            headers:{
                                'Content-Type':'application/json'
                            }
                        }
                    }else{//新增默认
                        params.score = -1;
                    }
                    Axios.post(url, params, {
                        headers:{
                            'Content-Type':'application/json'
                        }
                    }).then(res => {
                         if (res.status) {
                            let id = vm.type == '1' ? vm.data.pkid : res.data.data;
                            vm.bindTenderAttr(id);                         
                            Message.info({title:'提示',message: vm.type=='0' ? '添加成功！' : '修改成功！',type:'success'});
                            vm.$emit('submit');
                        }
                    }).catch(err => {
                        Message.info({title:'提示',message: vm.type=='0' ? '添加失败！' : '修改失败！',type:'error'});
                    })
                }
            });
        },
        cancel(){
            this.$emit('close');
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/ProjectManage/edit.vue